export enum PriceIndiceEnum {
    IGP = 1,
    ICV = 2,
    INCC = 3
}
